module.exports = __webpack_public_path__ + "static/media/airbnb-logo.7c13fd96.png";